






import { RegularFilterValueConfig } from '@empathybroker/tsclient-play/dist/models/instance/filters/regular-filter-value-config';

import { mapGetters } from 'vuex';

import { DeviceEnum, FilterTypeEnum, KpiEnum } from '../../../enums';

import { Filter, RegularFilter } from '../../../models';

import { CONTEXT_CONSTS } from '../../../store/context/context.consts';

import RadarChart from '../radar-chart.component.vue';

export default {
  name: 'pivots-chart',
  components: {
    RadarChart
  },
  computed: {
    ...mapGetters(CONTEXT_CONSTS.moduleName, {
      context: CONTEXT_CONSTS.getters.context
    }),
    radarChartParams: function () {
      const chartValues = [this.kpi];
      if (!!this.compareFilterValue) {
        chartValues.push('compare');
      }
      const chartData = this.data.map(pivot => {
        const comparePivotData = pivot[this.compareFilterValue];
        const comparePivotValue = !!comparePivotData && comparePivotData[this.selectedKpiKey];
        return {
          id: pivot.id,
          label: this.getPivotValueText(pivot.id),
          values: {
            [this.kpi]: pivot.currentPeriod[this.selectedKpiKey],
            compare: comparePivotValue
          }
        };
      }).slice(0, 10);
      chartData.sort((dataItem1, dataItem2) => dataItem1.id.localeCompare(dataItem2.id));
      return {
        config: {
          values: chartValues,
          maxValue: undefined,
          valueUnits: undefined
        },
        data: chartData
      };
    },
    selectedKpiKey: function (): string {
      return {
        [KpiEnum.QUERIES]: () => 'queryCount',
        [KpiEnum.NO_RESULTS]: () => 'noResultsCount',
        [KpiEnum.CLICKS]: () => 'clickCount',
        [KpiEnum.FINDABILITY]: () => 'findabilityCount',
        [KpiEnum.ADD2CART]: () => 'add2cartCount',
        [KpiEnum.CHECKOUT]: () => 'checkoutCount'
      }[this.kpi]();
    },
    isSmallDevice: function (): boolean {
      return (this.$epb.device > DeviceEnum.TABLET && this.$epb.device < DeviceEnum.LARGE_DESKTOP);
    }
  },
  data: function () {
    return {
      DeviceEnum
    };
  },
  props: {
    data: {
      type: Array,
      required: true
    },
    pivot: Object,
    kpi: KpiEnum,
    compareFilterValue: String
  },
  methods: {
    getPivotValueText: function (pivotValue: string): string {
      const pivotFilter = (Object.values(this.context.filters)
        .find((stateFilter: Filter) => ((stateFilter.config.type === FilterTypeEnum.REGULAR) &&
          (((stateFilter as RegularFilter).config.taggingId || stateFilter.config.id) === this.pivot.id))) as RegularFilter);
      if (!pivotFilter) {
        return pivotValue;
      }
      const pivotFilterValueConfig = pivotFilter.config.values.find((valueConfig: RegularFilterValueConfig) =>
        ((valueConfig.taggingId || valueConfig.id) === pivotValue));
      if (!pivotFilterValueConfig) {
        return pivotValue;
      }
      const pivotFilterValuesMessages = this.$epb.messages.filters.values[pivotFilter.config.id];
      return (pivotFilterValueConfig.prettyName ||
        (!!pivotFilterValuesMessages && pivotFilterValuesMessages[pivotFilterValueConfig.id]) || pivotFilterValueConfig.id);
    }
  }
};
